<template>
  <nav class="nav">
    <div class="brand">
      <icon id="houston" :scale="1.75" />
    </div>

    <ListStacked size="tight" class="menu">
      <li>
        <router-link
          :to="{ name: 'home' }"
          class="menu__btn btn btn--bare"
          :exact="true"
        >
          <icon id="map" class="mrgb-" />
          {{ $t('nav.map') }}
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'planification' }"
          class="menu__btn btn btn--bare"
          :exact="true"
        >
          <icon id="planification" class="mrgb-" />
          {{ $t('nav.planification') }}
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'directories' }"
          class="menu__btn btn btn--bare"
          :exact="true"
        >
          <icon id="phone-book" class="mrgb-" />
          {{ $t('nav.directories') }}
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'contacts' }"
          class="menu__btn btn btn--bare"
          :exact="true"
        >
          <icon id="contact" class="mrgb-" />
          {{ $t('nav.contacts') }}
        </router-link>
      </li>
      <li
        v-if="courseConnectionActivated && user.can_manage_course_connections"
        class="relative"
      >
        <ConnectionPopover />
        <router-link
          :to="{ name: 'courseConnection' }"
          class="menu__btn btn btn--bare"
          :exact="true"
        >
          <icon
            v-if="courseConnectionLocationActivated"
            :id="currentConnectionStateIconId"
            class="mrgb-"
          />
          <icon v-else id="clock" class="mrgb-" />
          {{ $t('nav.courseConnection') }}
        </router-link>
      </li>
    </ListStacked>
  </nav>
</template>
<script>
import ConnectionPopover from '@/components/courseConnection/ConnectionPopover.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    ConnectionPopover,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['courseConnectionActivated']),
    ...mapState('courses', [
      'courseConnectionsLocations',
      'courseConnectionLocationActivated',
    ]),
    ...mapGetters('courses', ['anyNextCourseBlocked', 'anyNextCourseDelayed']),
    currentConnectionStateIconId() {
      if (this.anyNextCourseBlocked) {
        return 'clock-activated-red';
      } else if (this.anyNextCourseDelayed) {
        return 'clock-activated-yellow';
      } else {
        return 'clock-activated';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  display: grid;
  grid-template-rows: auto 1fr;
  //overflow: hidden;

  position: relative;
  z-index: 3;

  background-color: $alt-700;
}

.brand {
  padding: 16px;

  color: $alt-700;
  text-align: center;

  position: relative;

  background-color: white;
  border-radius: 0 0 50% 50% / 0 0 10px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.menu {
  margin-top: -10px;

  > li:first-child .menu__btn {
    padding-top: 16px + 10px;
  }
}

.menu__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px $spacing-unit-tiny;

  font-size: rem(12px);
  color: $alt-200;
  line-height: 1;
  font-weight: bold;

  &:hover,
  &:focus,
  &.router-link-active {
    color: white;

    background-color: $alt-600;
  }
}
</style>
